import { ValidatorConstraintInterface, ValidatorConstraint } from 'class-validator';
import parsePhoneNumber from 'libphonenumber-js';

export const E164RegEx = /^\+[1-9]\d{1,14}$/;

@ValidatorConstraint({ name: 'PhoneNumberE164' })
export default class PhoneNumberE164IsValid implements ValidatorConstraintInterface {
  validate(currentValue: any) {
    const phone = parsePhoneNumber(currentValue);

    return phone ? phone.isValid() && E164RegEx.test(currentValue) : false;
  }

  defaultMessage() {
    return 'The phone number is not valid';
  }
}
